import { render, staticRenderFns } from "./ModalFormularioTipoDocumentoPersona.vue?vue&type=template&id=0a0a9bb3&scoped=true"
import script from "./ModalFormularioTipoDocumentoPersona.vue?vue&type=script&lang=js"
export * from "./ModalFormularioTipoDocumentoPersona.vue?vue&type=script&lang=js"
import style0 from "./ModalFormularioTipoDocumentoPersona.vue?vue&type=style&index=0&id=0a0a9bb3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0a9bb3",
  null
  
)

export default component.exports